import useLikeCounter from 'hooks/useLikeCounter'
import { classNames } from 'lib/utils/classnames'
import React, { FunctionComponent } from 'react'
import { Heart } from 'react-feather'
import TextDataLoader from './loaders/TextDataLoader'

interface ILikeButtonProps {
  slug: string
  type: 'blog' | 'snippet'
}

const LikeButton: FunctionComponent<ILikeButtonProps> = ({ slug, type = 'blog' }): JSX.Element => {
  const { isLikesLoading, totalLikes, totalLikesByUser, handleLikeClick } = useLikeCounter({
    slug,
    type,
  })

  return (
    <div className="flex flex-row justify-center lg:flex-col items-center gap-4">
      <h3 className="text-center font-bold text-sm uppercase text-gray-700 dark:text-gray-300">
        Liked it?
      </h3>
      <div className="flex items-center justify-center gap-2">
        <div className="relative">
          <button
            className={classNames(
              'shadow-lgx group relative block transform overflow-hidden rounded-lg bg-gradient-to-tl from-gray-300/5 to-gray-800/30 dark:from-white/5 dark:to-white/30 p-1.5 transition-all duration-300 ease-out hover:scale-125 hover:rounded-md active:scale-100 active:rounded-lg',
              {
                'animate-pulse': isLikesLoading,
                'hover:shadow-gray-500/30': totalLikesByUser === 0,
                'hover:shadow-purple-500/50': totalLikesByUser !== 0,
              }
            )}
            aria-label="like this article"
            onClick={handleLikeClick}
          >
            <div
              className={classNames(
                'absolute inset-0 transform-gpu bg-gradient-to-tl from-rose-500 to-red-400 transition-transform translate-y-9',
                {
                  'translate-y-9': totalLikesByUser === 0,
                  'translate-y-7': totalLikesByUser === 1,
                  'translate-y-6': totalLikesByUser === 2,
                  'translate-y-5': totalLikesByUser === 3,
                  'translate-y-4': totalLikesByUser === 4,
                  'translate-y-3': totalLikesByUser === 5,
                  'translate-y-2': totalLikesByUser === 6,
                  'translate-y-1': totalLikesByUser === 7,
                  'translate-y-0': totalLikesByUser === 8,
                }
              )}
            />

            <Heart className="relative w-5 transform text-rose-800 dark:text-rose-100 transition delay-100 duration-500 ease-out group-hover:scale-110" />
          </button>
        </div>

        {/* Like counter text */}
        <div className="text-lg font-medium leading-none text-rose-800/90 dark:text-rose-100/90">
          {isLikesLoading ? <TextDataLoader /> : <span>{totalLikes}</span>}
        </div>
      </div>
    </div>
  )
}

export default LikeButton
